import { api } from "@/lib/orgApi";

const BASE = "/table-designer";

export function listTables() {
  return api.get(`${BASE}/tables`).then((response) => response.data || {});
}

export function getNewTableTemplate() {
  return api.get(`${BASE}/tables/new`).then((response) => response.data || {});
}

export function getTable(schema, name) {
  return api
    .get(`${BASE}/tables/${encodeURIComponent(schema)}/${encodeURIComponent(name)}`)
    .then((response) => response.data || {});
}

export function getTableData(schema, name, { limit = 25, offset = 0, q = "", columns = [] } = {}) {
  const params = { limit, offset };
  if (q) params.q = q;
  if (columns.length) params.columns = columns.join(",");
  return api
    .get(`${BASE}/tables/${encodeURIComponent(schema)}/${encodeURIComponent(name)}/data`, { params })
    .then((response) => response.data || {});
}

export function previewSql(payload) {
  return api.post(`${BASE}/preview-sql`, payload).then((response) => response.data || {});
}

export function saveTable(payload) {
  return api.post(`${BASE}/tables`, payload).then((response) => response.data || {});
}

export function getFormCatalog() {
  return api.get(`${BASE}/form-catalog`).then((response) => response.data || {});
}

export function getFormTableFields(schema, name) {
  return api
    .get(`${BASE}/form-catalog/${encodeURIComponent(schema)}/${encodeURIComponent(name)}`)
    .then((response) => response.data || {});
}

export function listForms() {
  return api.get(`${BASE}/forms`).then((response) => response.data || {});
}

export function saveForm(payload) {
  return api.post(`${BASE}/forms`, payload).then((response) => response.data || {});
}
